export default "__VITE_ASSET__w8AuXphQ__"